import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../settings/index';
import Api, { executeAction } from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import { t } from '../../../i18n';

const api = new Api('dashboard/jobs_at_risks');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, filter = '', job_group_id, expand, currentPage } = payload;
    const isLoadMoreClicked = job_group_id && expand;

    const result = yield call(
      sendRequest,
      api.load,
      {
        search: {
          ...payload,
          page: isLoadMoreClicked ? 1 : page, // When load more has been clicked set page to 1 but increase pageSize
          pageSize,
          filter,
          job_group_id,
          column: 'risk_score',
          order: 'descend',
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns, job_group, filters, saved_searches } =
        result.data.success.data;

      if (job_group && expand) {
        yield put(
          actions.loadMultiDayDataSuccess({
            data: records,
            total: totalCount,
            pageSize,
            currentPage,
            filteredTotal: filteredCount,
            sortableColumns: sortable_columns,
            jobGroup: job_group,
            savedSearches: saved_searches,
          }),
        );
      } else {
        yield put(
          actions.loadDataSuccess({
            data: records,
            total: totalCount,
            filteredTotal: filteredCount,
            pageSize,
            sortableColumns: sortable_columns,
            jobGroup: job_group,
            filters,
            savedSearches: saved_searches,
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* actionRequest({ payload }) {
  try {
    const { method, url } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.logged', {
            item: t('dash.landingPage.jobs_at_risk.risk_feedback_label'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.ACTION_REQUEST, actionRequest)]);
}
